module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedit"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALPH AND")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OONEY")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("who know all the answers")]), _vm._v("!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539b77a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Dedication.vue
// module id = 72
// module chunks = 0